import styled, { css } from 'styled-components';
import Button from './index';

const funzioneCalcoloStile = ({ theme, btnType, disabled }) => {
  let style;
  switch (btnType) {
    case Button.TYPE.PRIMARY:
      style = css`
        background-color: ${theme.colors.secondary};
        color: ${theme.colors.white};
        border: transparent;
        ${disabled &&
          css`
            opacity: 0.5;
          `}
      `;
      break;
    case Button.TYPE.SECONDARY:
      style = css`
        color: ${theme.colors.secondary};
        background-color: ${theme.colors.white};
        border: 4px solid ${theme.colors.secondary};
        ${disabled &&
          css`
            opacity: 0.5;
          `}
      `;
      break;
    case Button.TYPE.TERTIARY:
      style = css`
        color: ${theme.colors.white};
        background-color: transparent;
        border: 4px solid ${theme.colors.white};
        ${disabled &&
          css`
            opacity: 0.5;
          `}
      `;
      break;
    case Button.TYPE.FOURTH:
      style = css`
        color: ${theme.colors.primary};
        background-color: ${theme.colors.white};
        border: 4px solid ${theme.colors.primary};
        ${disabled &&
          css`
            opacity: 0.5;
          `}
      `;
      break;

    default:
      break;
  }

  return style;
};

export const ButtonContainer = styled.button`
  position: relative;
  width: ${({ minWidth }) => `${minWidth}px`};
  min-width: fit-content;
  min-height: ${({ minHeight }) => `${minHeight}px`};
  white-space: nowrap;
  transition: all 0.125s ease-in;
  -ms-transition: all 0.125s ease-in;
  text-transform: uppercase;
  border-radius: 16px;
  font-size: 22px !important;
  font-style: normal;
  font-weight: 700;
  padding: 16px;
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};

  @media ${props => props.theme.device.desktopXL} {
    padding: 24px;
  }
  @media ${props => props.theme.device.max} {
    padding: 32px;
  }

  &:hover {
    box-shadow: 8px 8px 0px 0px #1e1e1e;
  }

  ${props => funzioneCalcoloStile(props)};
`;
